import { ReactElement, ReactNode, useEffect } from 'react'
import _refiner from 'refiner-js'

import { useUserOrganization } from '@modules-deprecated/app/organization/userOrganizationContext'
import { useCurrentUser } from '@modules-deprecated/app/user'

import { IS_DEVELOPMENT } from '../../utils/isDevelopment'

interface RefinerInitializerProps {
  children: ReactNode
}

export const RefinerInitializer = ({ children }: RefinerInitializerProps): ReactElement => {
  const { user } = useCurrentUser()
  const { organization } = useUserOrganization()

  useEffect(() => {
    const projectId = window.ENV?.REFINER_PROJECT_ID
    if (IS_DEVELOPMENT || !projectId || !user?.globalId || !organization?.globalId) {
      return
    }
    _refiner('setProject', projectId)
    _refiner('identifyUser', {
      id: user.globalId,
      email: user.email,
      companyId: organization.globalId,
      planName: organization.subscriptionProductPlan,
      appName: window.ENV.theme,
    })
  }, [user?.globalId, organization?.globalId, user?.email, organization?.subscriptionProductPlan])

  return <>{children}</>
}
